export default __webpack_public_path__ + "static/media/AR1.a0c15d15.svg";